import VueGtm from '@gtm-support/vue2-gtm';

/// Usage
// To use Google Tag Manager add
// +import TagManager from '@shared/plugins/TagManager';
// +Vue.use(TagManager);
// in the projects main.ts

// But we have to find a better way to fix this import,
// because we have to add a new file into the project folder to get rid of import errors:
// shims-gtm.d.ts
// declare module '@shared/plugins/TagManager'

// Now we can add the tracking code into our components:
// // @ts-ignore
// this.$gtm.trackEvent({
//   event: 'sendt_form',
//   category: 'BliKunde',
//   action: 'B2C',
//   label: 'Kundeservice Blikunde',
//   customerType: 'B2C',
// });

// Unfortunately this.$gtm is not found, so we need to
// add a new line into .eslintrc.js to supress the lint error
// rules: {
// +    '@typescript-eslint/ban-ts-comment': 'off',
// +    '@typescript-eslint/ban-ts-ignore': 'off',
// },

// @ts-ignore
const install = (Vue) => {
  Vue.use(VueGtm, {
    id: 'GTM-K5TKMJV', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id:
    defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
    compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: true, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
  });
};

// Plugin
const TagManager = {
  // eslint-disable-next-line no-undef
  install,
};

export default TagManager;

// Auto-install
let GlobalVue = null;
if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
  // @ts-ignore
} else if (typeof global !== 'undefined') {
  // @ts-ignore
  GlobalVue = global.Vue;
}
if (GlobalVue) {
  GlobalVue.use(TagManager);
}
